
export function submitOnEnter(btnSelector, inputSelector) {
    let el = document.querySelector(inputSelector);
    if(!el)
        return;
    el.addEventListener("keydown", function (event) {
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
            event.preventDefault();
            document.querySelector(btnSelector).click();
        }
    });
}
